import styled from "styled-components";

export const CloseBtn = styled.button`
  position: absolute;
  display: grid;
  place-items: center;
  right: 0.5rem;
  top: 0.5rem;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  border: none;
  background-color: #e1e1e1;
`;
